import { render } from "./ViewLeaveRequestModal.vue?vue&type=template&id=1849d274"
import script from "./ViewLeaveRequestModal.vue?vue&type=script&lang=js"
export * from "./ViewLeaveRequestModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__